(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabn-homepage"] && !Shopify.designMode) return;
  try {
    
  const cabnHomePreviewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (cabnHomePreviewThemeId) {
    document.querySelectorAll('.cabn-home a[href^="/"]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.set('preview_theme_id', cabnHomePreviewThemeId);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  }

  const cabnHomeVideos = document.querySelectorAll('[data-lazy-video]');
  const cabnHomeReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const loadCabnHomeVideo = (video) => {
    const source = video.querySelector('source[data-src]');
    if (!source || source.src) return;
    source.src = source.dataset.src;
    video.load();
    if (!cabnHomeReducedMotion) video.play().catch(() => {});
  };

  if ('IntersectionObserver' in window) {
    const cabnHomeObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadCabnHomeVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    cabnHomeVideos.forEach((video) => cabnHomeObserver.observe(video));
  } else {
    cabnHomeVideos.forEach(loadCabnHomeVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
